// src/context/AuthContext.js

import React, { useContext, useState, useEffect } from 'react';
import { auth } from '../config/firebase';
import { onAuthStateChanged } from 'firebase/auth';

// Create the context
const AuthContext = React.createContext();

// Custom hook to allow components to access the context
export function useAuth() {
  return useContext(AuthContext);
}

// The provider component that will wrap our entire app
export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // This effect runs once on mount to set up a listener
  useEffect(() => {
    // onAuthStateChanged is Firebase's real-time listener for auth state
    const unsubscribe = onAuthStateChanged(auth, user => {
      setCurrentUser(user);
      setLoading(false); // We are no longer loading once we have the user status
    });

    // Cleanup the listener when the component unmounts
    return unsubscribe;
  }, []);

  const value = {
    currentUser,
  };

  // We don't render the app until the loading state is false
  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}